/*=========================================================================================
  File Name: state.js
  Namespace: labs
  Description: Vuex Store - Lab state
==========================================================================================*/

const LAB_POSSIBLE_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
}

export const LAB_POSSIBLE_DIFFICULTY = {
  INFORMATIVE: 'informative',
  NOVICE: 'novice',
  PROFESSIONAL: 'professional',
  ADVANCED: 'advanced',
  EXPERT: 'expert',
}

export const buildLabState = () => {
  return {
    id: null,
    name: '',
    slug: null,
    created: null,
    modified: null,
    status: null,
    description: '',
    description_html: '',
    lab_type: null,
    company: null,
    external_url: null,
    lab_objectives: [],
    metadata: {
      els_lab_id: null,
    },
    instructor_id: null,
    explanation_video: null,
    is_lab_experience: false,
    is_featured: false,
    is_skill_check: false,
    solution_video: null,
    duration_in_seconds: 0,
    difficulty: null,
    learning_areas: [],
    categories: [],
    tags: [],
    severity: null,
    cve: null,
    year: null,
    classification: null,
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentLab: buildLabState(),
  objectives: [],
  labList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
  LAB_POSSIBLE_STATUS,
  LAB_POSSIBLE_DIFFICULTY,
  categoryList: {},
  categoryPagination: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
}

export default state
